import { Button } from "antd";
import { useDispatch } from "react-redux";
import { setFormState } from "../../redux/store/emailLoginSlice";

export default function FormStateButtons({ formState }) {
  const dispatch = useDispatch();

  const buttonConfig = {
    login: {
      text: "Don't have an account? Sign up",
      onClick: () => dispatch(setFormState("signup")),
      style: { marginBottom: "20px" },
    },
    signup: {
      text: "Already have an account? Log in",
      onClick: () => dispatch(setFormState("login")),
      style: {},
    },
    forgot: {
      text: "Back to Login",
      onClick: () => dispatch(setFormState("login")),
      style: {},
    },
  };

  const config = buttonConfig[formState];

  if (!config) return null;

  return (
    <div style={{ padding: "24px 0px" }}>
      <Button type="link" onClick={config.onClick} block style={config.style}>
        {config.text}
      </Button>
    </div>
  );
}
